import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  CatalogCardCategoriesListResponseData,
  CatalogCardShowResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CATALOG_CARD_CATEGORIES_LIST_QUERY_KEY =
  'catalog_card_categories_list';

export const CATALOG_CARD_QUERY_KEY = 'catalog_card';

// The tree renders the whole catalog at once — override the RTable default (100 rows).
const CATALOG_TREE_PAGE_SIZE = 1000;

export const useCatalogCardCategoriesQuery = (
  url: string,
  filters?: Record<string, unknown>,
) =>
  useQuery({
    queryKey: [CATALOG_CARD_CATEGORIES_LIST_QUERY_KEY, url, filters],
    queryFn: () =>
      HttpClient.request<CatalogCardCategoriesListResponseData>({
        method: 'GET',
        url,
        params: {
          size_per_page: CATALOG_TREE_PAGE_SIZE,
          ...(filters ? { filters } : {}),
        },
      }),
    enabled: !!url,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

export const useCatalogCardQuery = (fetchUrl: string) =>
  useQuery({
    queryKey: [CATALOG_CARD_QUERY_KEY, fetchUrl],
    queryFn: () =>
      HttpClient.request<CatalogCardShowResponseData>({
        method: 'GET',
        url: fetchUrl,
      }),
    enabled: !!fetchUrl,
    refetchOnWindowFocus: true,
    placeholderData: keepPreviousData,
  });
